<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-two">
<h1>Chapter Two</h1>
<p>There was something about Joshua Darlington that, inexplicably, stole a tiny fraction of Abigail Hunter’s attention. What was that <em>something</em> she did not know. Desperately, she tried to override it—to banish it out of her system. She could not. Whatever <em>it</em> was, it was beyond her comprehension and ultimately beyond her control. And so, every morning, her eyes inadvertently switched to him, and, for a few secret moments, she savoured his presence before she managed to drag her eyes away and vowed never to look in his direction again.</p>
<p>As the first orange-yellow leaves fell, her thoughts fell on the boy she had vowed to ignore. Like autumn, she thought, there was an underlying sadness about him, but there was also <em>something</em> that suggested another side to him—a secret, perhaps a darker, troubled side.</p>
<p>Nearing the gate, she snapped out of her reverie. Whether Joshua Darlington was or wasn’t troubled, it had nothing to do with her, she told herself firmly. If she was ever to get into nursing school, she would have to banish all dead-end reveries; banish the likes of Joshua Darlington out of her mind and think, breathe, and live for her studies and nothing or no one else.</p>
<p>Life at home was good. Alan and Mary Hunter had never lost their love for each other or their one and only child. Abigail was their pride and joy, their precious jewel, cementing their love. Supported and loved Abigail basked, flourished, and matured by the examples her parents set, thriving in a haven where all rejoiced in each other’s achievements, no matter how small, big, or inconsequential they seemed to others.</p>
<p>For devout Roman Catholics, prayer was at the top of their individual daily agendas. There was a secret figure Abigail prayed to each day; she shared this spiritual being with no one, and it was to this spiritual being, her guardian angel, that she related all her joys, secret sorrows, achievements, dreams, disappointments, and anxieties. She received no verbal answers, but she still carried on.</p>
<p>The bedside lamp switched off and abruptly went back on.</p>
<p>“Oh, I forgot, guardian angel, as from midnight, Joshua Darlington will be wiped away from my thoughts forever.”</p>
<p>The light snapped off, and her eyes stared into the darkness, seeing only one prevailing, defiant image.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?997c86fc